import { useEffect, useState } from "react";
import segmentFlights from "../../../utils/flight/segmentFlights";
import { clone } from "lodash";
import SeatSelection from "../../../pages/Orders/Flight/Book/SeatSelection";
import useOffer from "../../../hooks/flight/useOffer";
import { CircularProgress } from "@mui/material";

export default function SeatSelectionHandler({offer, setSeatsPrice}) {
  const {getSeatMap} = useOffer();

  const [loadings, setLoadings] = useState({load: false});
  
  let totalPassenger = Object.values(offer?.travelers || {})
  .map((o) => o?.total || 1)
  .reduce((p, c) => p + c, 0);

  
  useEffect(() => {
    load();
  },[])

  async function load() {
    setLoadings({load: true})
    const res = await getSeatMap(offer);
    setLoadings({load: false})
  }
  
  const segments = segmentFlights(offer?.flights || []);
  
  const [seats, setSeats] = useState([
    ...segments.map((seg) =>
      seg.map((f) => [...Array(totalPassenger)])
    )||[],
  ]);

  function handleSeat(obj, { i, j, seg }) {
    // console.log(" => ",obj,i)
    try {
      const { seatNumber, ...restObj } = obj[0] || {};
      let temp = clone(seats);
      // console.log(temp,seg,i,j)
      const newObj = seatNumber
        ? { seatNumber, passenger: i, ...restObj }
        : null;
      // if(seatNumber)
      temp[seg][j][i] = newObj;
      setSeats(temp);
      // console.log(temp,temp?.map(arr => arr?.flat())?.flat())
      setSeatsPrice(temp?.map((arr) => arr?.flat() || [])?.flat());
    } catch (ex) {
      console.log(ex);
    }
  }

  console.log(offer,'offer in seat selection handler');
  
  return (
    <div>
      {loadings.load ?
        <div className="flex justify-center items-center">
          <CircularProgress />
        </div>
      :null}
      {Object.entries(offer?.travelers || {})
        .flatMap(([type, obj]) =>
          Array.from({ length: obj.total }, () => ({ type: obj?.travelerType, ...obj }))
        )
        .map(({ type }, i) => {
          return (
            <div>
              <SeatSelection
                callback={(obj, { i: seg, j }) =>
                  handleSeat(obj, { i, j, seg })
                }
                offer={offer}
                hide={["info"]}
              />
            </div>
          )
        })
      }

    </div>
  )
}